import { render } from "./VideoPopup.vue?vue&type=template&id=cb6dc686"
import script from "./VideoPopup.vue?vue&type=script&lang=js"
export * from "./VideoPopup.vue?vue&type=script&lang=js"

import "./VideoPopup.vue?vue&type=style&index=0&id=cb6dc686&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__